import React, { memo, useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { useTranslation } from "react-i18next";
import AuthLoader from "../../Login/AuthLoader";
// import { getAdminProfile, getUserById } from "@/services/organizationService/AdminService";

const Header = ({ toggleSidebar }) => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const dropdownRef = useRef(null); // Ref for dropdown
  // const [profileData, setProfileData] = useState(null);
  const location = useLocation();

  // for language change
  const { i18n } = useTranslation();
  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));


  const [selectedLang, setSelectedLang] = useState(i18n.language?.split('-')[0] || 'en');

  useEffect(() => {
    if (i18n.language) {
      const lang = i18n.language.split('-')[0];
      setSelectedLang(lang);
    }
  }, [i18n.language]);

  const changeLanguage = async (e) => {
    const newLang = e.target.value;
    await i18n.changeLanguage(newLang);
    setSelectedLang(newLang);
    localStorage.setItem('i18nextLng', newLang);
  };


  // useEffect(() => {
  //   const fetchProfile = async () => {
  //     if (auth && auth.id) {
  //       if (auth.role === "ADMIN") {
  //         try {
  //           const data = await getAdminProfile(auth.id);
  //           setProfileData(data);
  //         } catch (error) {
  //           console.error("Failed to fetch admin profile in header", error);
  //         }
  //       } else if (auth.role === "USER") {
  //         try {
  //           const data = await getUserById(auth.id);
  //           setProfileData(data);
  //         } catch (error) {
  //           console.error("Failed to fetch user profile in header", error);
  //         }
  //       }
  //     }
  //   };
  //   fetchProfile();
  // }, [auth]); 

  const MIN_LOGOUT_LOADING_TIME = 2000;

  const handleLogout = async () => {
    setLogoutLoading(true);

    await delay(MIN_LOGOUT_LOADING_TIME);

    logout();
    navigate("/smartcity/login", { replace: true });
    setLogoutLoading(false);
  };

  // Use profileData if available, otherwise fall back to auth context data
  const displayName = user?.firstName;
  // console.log(displayName);
  const displayEmail = user?.email;


  const firstLetter = displayName ? displayName[0].toUpperCase() : "?";

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  //  Close dropdown when route changes
  useEffect(() => {
    setOpen(false);
  }, [location]);


  // useEffect(() => {

  //   const closeDropdown = () => setOpen(false);
  //   navigate(closeDropdown);
  // }, [navigate]);  

  const handleMenuClick = (route) => {
    setOpen(false);
    navigate(route);  // Navigate to the desired route
  };

  if (!user) return null;

  return (
    <>
      {logoutLoading && <AuthLoader text="Signing you out securely..." />}

      <header className="flex justify-between items-center p-2 md:p-4 bg-white relative z-10">
        {/* Mobile toggle */}
        <button
          onClick={toggleSidebar}
          className="md:hidden p-2 text-xl rounded hover:bg-gray-200"
        >
          ☰
        </button>

        {/* Greeting */}
        <h2 className="md:block hidden font-bold text-blue">
          {user?.role === "ADMIN" && <span>Admin Panel</span>}
        </h2>

        {/* Right side actions */}
        <div className="flex items-center gap-4">
          {/* Profile Avatar & Dropdown (only for non-SUPER_ADMIN) */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setOpen(!open)}
              className="w-10 h-10 rounded-full bg-gray-200 flex cursor-pointer items-center justify-center overflow-hidden border-2 border-gray-300"
            >
              <span className="text-lg font-bold text-gray-600">
                {firstLetter}
              </span>
            </button>

            {open && (
              <div className="absolute right-0 mt-2 w-64 bg-white shadow-lg rounded-xl p-4 border z-40">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden">

                    <span className="text-xl font-bold text-gray-600">
                      {firstLetter}
                    </span>

                  </div>
                  <div className="space-y-2">
                    <p className="text-sm font-semibold">{displayName}</p>
                    <p className="text-xs text-gray-500">{displayEmail}</p>
                  </div>
                </div>
                {/* <select
                  onChange={changeLanguage}
                  className="border rounded-md p-1 text-sm bg-gray-50 cursor-pointer"
                  value={selectedLang}
                >
                  <option value="en">English</option>
                  <option value="mr">मराठी</option>
                  <option value="hi">हिन्दी</option>
                </select> */}

                <div className="mt-4 space-y-2">
                  <button
                    onClick={handleLogout}
                    disabled={logoutLoading}
                    className={`w-full px-3 py-2 text-sm rounded-md bg-red-100 
  ${logoutLoading ? "opacity-60 cursor-not-allowed" : "hover:bg-red-200"} 
  text-red-600`}
                  >
                    {logoutLoading ? "Signing out..." : "Logout"}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default memo(Header);
